<template>
  <div>
    <h1>Show {{ item && item['@id'] }}</h1>

    <div
      v-if="isLoading"
      class="alert alert-info"
      role="status">Loading...</div>
    <div
      v-if="error"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true">{{ error }}</span>
    </div>
    <div
      v-if="deleteError"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true">{{ deleteError }}</span>
    </div>
    <div
      v-if="item"
      class="table-responsive">
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th>Field</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">Name</th>
            <td>{{ item['name'] }}</td>
          </tr>
          <tr>
            <th scope="row">Image</th>
            <img :src="imageUrl + '/media/' +  item['image'].filePath">
          </tr>          
          <!-- <tr>
            <th scope="row">Image</th>
            <div v-for="selectItem in imageSelectItems" :key="selectItem['@id']">
              <div v-if="selectItem['@id'] == item['image']">
                <img :src="imageUrl + selectItem['contentUrl']">                
              </div>        
            </div>               
          </tr> -->
        </tbody>
      </table>
    </div>

    <router-link
      :to="{ name: 'SpeakerList' }"
      class="btn btn-primary">
      Back to list
    </router-link>
    <router-link
      v-if="item"
      :to="{ name: 'SpeakerUpdate', params: { id: item['@id'] } }"
      class="btn btn-warning">
      Edit
    </router-link>
    <button
      class="btn btn-danger"
      @click="deleteItem(item)">Delete</button>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import apiUrl from '../../store/modules/links/links';

export default {
  data() {
    return {
      imageUrl: apiUrl.API_HOST,
    }
  },
  computed: {
    ...mapFields('speaker/del', {
      deleteError: 'error',
    }),
    ...mapFields('speaker/show', {
      error: 'error',
      isLoading: 'isLoading',
      item: 'retrieved',
    }),
    ...mapFields('mediaobject/list', {
      'imageSelectItems': 'selectItems',
    }),        
  },

  beforeDestroy () {
    this.reset();
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id));
    this.imageGetSelectItems();
  },

  mounted() {    
  },

  methods: {
    ...mapActions({
      del: 'speaker/del/del',
      reset: 'speaker/show/reset',
      retrieve: 'speaker/show/retrieve',
    }),
    ...mapActions({
        imageGetSelectItems: 'mediaobject/list/getSelectItems',
    }),

    deleteItem (item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        this.del(item).then(() => this.$router.push({ name: 'SpeakerList' }));
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/speaker/Show.vue